import { getSafeErrorFields } from '../../errors';
import { logger } from './logger';

/**
 * A release runs a targeted disconnect, which throws when that edge is not
 * wired yet; on a constructor's error path it must neither replace that error
 * nor skip the other release.
 */
export const releaseAnalyzerId = (release: (id: string) => void, id: string): void => {
  try {
    release(id);
  } catch (err) {
    logger.warn({
      event_type: 'ANALYZER_RELEASE_FAILED',
      details: { id, ...getSafeErrorFields(err) },
    });
  }
};
